import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EmergencyService',
    controller: 'EmergencyEvent'
};

const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'DelItemList',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetEventSummaryStatistical',
    'GetEmergencyIncidentList',
    'GetEventReport'
];

const factory = (Fun) => {
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function (data) {
            return this.post(path, data)
        }
    })
};
const EmergencyEventApi = ZJApi.defineNewApi('EmergencyEventApi', factory);

export default EmergencyEventApi;